import {
  getListSurveyQuestions,submitSurvey
} from '@/services/survey';

const getters = {
  listSurveyQuestion: state => state.listSurveyQuestion
};

const actions = {
  async requestListSurveyQuestions({ commit, rootGetters }) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    let returnRes = [];
    try {
      const response = await getListSurveyQuestions({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] });
      returnRes = response.data!==undefined?response.data:[];
      commit('SET_LIST', returnRes);
      commit('NotificationModule/SET_STATUS', { status: 200, message: ``, errorCode: null }, { root: true });
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: err.status, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
    return returnRes;
  },
  async requestSubmitSurvey({ commit, rootGetters },data) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const response = await submitSurvey({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] },data);
      commit('NotificationModule/SET_STATUS', { status: 200, message: ``, errorCode: null }, { root: true });
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: err.status, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
};

const mutations = {
  SET_LIST(state, listSurveyQuestion) {
    state.listSurveyQuestion = listSurveyQuestion;
  },
};

export default {
  namespaced: true,
  state: {
    listSurveyQuestion: [],
  },
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/stores/Survey/index.js